import { withInstall } from '../utils/index';
import Text from './index.vue';
import './index.less';

export const TlbsText = withInstall(Text);
export default TlbsText;
